export default {
  MASTER: 1,
  ADM: 2,
  OPERATOR: 3,
  COMMERCIAL: 4
};
